import * as _ from 'lodash'
import {PAdbContext} from './PAdbContext'
import {esWB_Domain, esWB_Domain_Item, esWB_Event_Type, esWB_Meta, esWB_Spend_Type} from "./PAdbSchema";
import {WB_DomainItemRow, WB_DomainRow, WB_EventTypeRow, WB_MetaRow, WB_SpendTypeRow} from "./PAdbSchemaRows";
import {PASearch} from "./PASearch";

  export interface IKeySetStats {

      wbMDSetId: number,
      wbSetId: number,
      SetType: string,
      SetId: string,
      TableSrc: string
      RecordCount: number
  }

  export function Domain_getDefaultOrFirstItem(dbContext: PAdbContext, sDomainIds: string[], bReturnDOMITEMID: boolean = false): Promise<string | number> {

    return new Promise<string | number>((resolve, error) => {

      const empty = (bReturnDOMITEMID) ? "" : 0

      if (_.isEmpty(sDomainIds) || _.isEmpty(dbContext)) {
        resolve(empty)
      }

      dbContext.findAll(esWB_Domain, {where: {DOMAIN_ID: {inq: sDomainIds}, DELETED_IND: {neq: '1'}}})
        .then((arrWBDomRows: WB_DomainRow[]) => {
          if (_.isEmpty(arrWBDomRows)) {
            resolve(empty)
            return
          }

          let arrWBDomIds: number [] = []
          _.forEach(arrWBDomRows, (aWB_DomRow: WB_DomainRow) => {
            arrWBDomIds.push(aWB_DomRow.cif.WB_DOM_ID)
          })

          return dbContext.findAll(esWB_Domain_Item,
            {
              where: {WB_DOM_ID: {inq: arrWBDomIds}, DELETED_IND: {neq: '1'}},
              limit: 1,
              orderBy: [['DEFAULT_IND', 'DESC'],
                ['DOMAIN_ITEM_SORT', 'ASC'],
                ['DOMAIN_ITEM_NAME', 'ASC']]
            })

        }).then((arrDomainItems: WB_DomainItemRow[]) => {
        if (_.isEmpty(arrDomainItems)) {
          resolve(empty)
          return
        }

        let aWB_DomItem = arrDomainItems[0]
        if (bReturnDOMITEMID) {
          resolve(aWB_DomItem.cif.DOMAIN_ITEM_ID)
        } else {
          resolve(aWB_DomItem.cif.WB_DOMITEM_ID)
        }

      }).catch((err) => {
        error(err)
      })

    })


  }

  export function Domain_getItems(dbContext: PAdbContext, sDomainIds: string[]): Promise<WB_DomainItemRow[]> {

  return new Promise<WB_DomainItemRow[]>((resolve, error) => {


    if (_.isEmpty(sDomainIds) || _.isEmpty(dbContext)) {
      resolve([])
    }

    dbContext.findAll(esWB_Domain, {where: {DOMAIN_ID: {inq: sDomainIds}, DELETED_IND: {neq: '1'}}})
      .then((arrWBDomRows: WB_DomainRow[]) => {
        if (_.isEmpty(arrWBDomRows)) {
          resolve([])
          return
        }

        let arrWBDomIds: number [] = []
        _.forEach(arrWBDomRows, (aWB_DomRow: WB_DomainRow) => {
          arrWBDomIds.push(aWB_DomRow.cif.WB_DOM_ID)
        })

        return dbContext.findAll(esWB_Domain_Item,
          {
            where: {WB_DOM_ID: {inq: arrWBDomIds},EXCLUDE_IND:  {in: ['0','']}, DELETED_IND: {neq: '1'}},

            orderBy: [['DEFAULT_IND', 'DESC'],
              ['DOMAIN_ITEM_SORT', 'ASC'],
              ['DOMAIN_ITEM_NAME', 'ASC']]
          })

      }).then((arrDomainItems: WB_DomainItemRow[]) => {
      if (_.isEmpty(arrDomainItems)) {
        resolve([])
        return
      }

      resolve(arrDomainItems)

    }).catch((err) => {
      error(err)
    })

  })


}

  export function Meta_getDefaultOrFirstItem(dbContext: PAdbContext, arrMetaTypeIds: string[], bReturnMETAID: boolean = false): Promise<string | number> {

    return new Promise<string | number>((resolve, error) => {

      const empty = (bReturnMETAID) ? "" : 0

      if (_.isEmpty(arrMetaTypeIds) || _.isEmpty(dbContext)) {
        resolve(empty)
      }
      dbContext.findAll(esWB_Meta,
            {
              where: {META_TYPE_ID: {inq: arrMetaTypeIds}},
              limit: 1,
              orderBy: [['DEFAULT_IND', 'DESC'],
                        ['META_SORT_ID', 'ASC'],
                        ['META_NAME', 'ASC']]
            }).then((arrMetas: WB_MetaRow[]) => {
        if (_.isEmpty(arrMetas)) {
          resolve(empty)
          return
        }

        let aWB_Meta = arrMetas[0]
        if (bReturnMETAID) {
          resolve(aWB_Meta.cif.META_ID)
        } else {
          resolve(aWB_Meta.cif.WB_META_ID)
        }

      }).catch((err) => {
        error(err)
      })

    })

  }

  export function SpendType_getDefaultOrFirstItem(dbContext: PAdbContext, arrSourceIds: string[] = [], bReturnSpendTypeID: boolean = false): Promise<string | number> {

    return new Promise<string | number>((resolve, error) => {

      const empty = (bReturnSpendTypeID) ? "" : 0

      if (_.isEmpty(dbContext)) {
        resolve(empty)
      }

      let query:any = {
        where: {},
        limit: 1,
        orderBy: [['DEFAULT_IND', 'DESC'],
                  ['SPEND_TYPE_NAME', 'ASC']]
      }

      if (!_.isEmpty(arrSourceIds)) {
        query.where = {SOURCE_ID: {inq: arrSourceIds}}
      }

      dbContext.findAll(esWB_Spend_Type, query)
        .then((arrSpendTypes: WB_SpendTypeRow[]) => {
        if (_.isEmpty(arrSpendTypes)) {
          resolve(empty)
          return
        }

        let aWB_SpendType = arrSpendTypes[0]
        if (bReturnSpendTypeID) {
          resolve(aWB_SpendType.cif.SPEND_TYPE_ID)
        } else {
          resolve(aWB_SpendType.cif.WB_SPENDM_ID)
        }

      }).catch((err) => {
        error(err)
      })

    })

  }

  export function EventType_getDefaultOrFirstItem(dbContext: PAdbContext, arrSourceIds: string[] = [], bReturnEventTypeID: boolean = false): Promise<string | number> {

  return new Promise<string | number>((resolve, error) => {

    const empty = (bReturnEventTypeID) ? "" : 0

    if (_.isEmpty(dbContext)) {
      resolve(empty)
    }

    let query:any = {
      where: {},
      limit: 1,
      orderBy: [['DEFAULT_IND', 'DESC'],
        ['TYPE_NAME', 'ASC']]
    }

    if (!_.isEmpty(arrSourceIds)) {
      query.where = {SOURCE_ID: {inq: arrSourceIds}}
    }

    dbContext.findAll(esWB_Event_Type, query)
      .then((arrEventTypes: WB_EventTypeRow[]) => {
        if (_.isEmpty(arrEventTypes)) {
          resolve(empty)
          return
        }

        let aWB_EventType = arrEventTypes[0]
        if (bReturnEventTypeID) {
          resolve(aWB_EventType.cif.TYPE_ID)
        } else {
          resolve(aWB_EventType.cif.WB_EVTTPYE_ID)
        }

      }).catch((err) => {
      error(err)
    })

  })

}

  export async function SourceKeySet_getStats(options?: any): Promise<IKeySetStats[]> {

    let results: {TABLE_SRC: string, WB_MDSET_ID: number, WB_SET_ID: number, SET_TYPE: string, SET_ID: string, RECORD_COUNT: number}[]
        = await PASearch.find("vUI_SetRecordCounts", {}, {}, [], 0,[],)

      return _.map(results, (a) => {
          return {
              wbMDSetId: +a.WB_MDSET_ID,
              wbSetId: +a.WB_SET_ID,
              SetType: a.SET_TYPE,
              SetId: a.SET_ID,
              TableSrc: a.TABLE_SRC,
              RecordCount: a.RECORD_COUNT
          }
      })
  }
